import React, {useState} from 'react'
import {Helmet} from 'react-helmet';
import {Toast, Button} from 'aurorui';
import './style.css';
import { ComponentScreen } from '../component-screen';
import { PropsTable } from '../../components';

function ToastScreen() {
    const [showerrorDrawer, setShowErroDrawer] = useState(false);
    const [showsuccessDrawer, setShowSuccessDrawer] = useState(false);
    const [showinfoDrawer, setShowInfoDrawer] = useState(false);
    const [showwarningDrawer, setShowWarningDrawer] = useState(false);
    const openErrorDrawer = () => {
        // console.log("hello")
        setShowErroDrawer(true);
        setTimeout(()=>{
          setShowErroDrawer(false)
        },4000);
    };
    const openSuccessDrawer = () => {
        // console.log("hello")
        setShowSuccessDrawer(true);
        setTimeout(()=>{
          setShowSuccessDrawer(false)
        },4000);
    };
    const openInfoDrawer = () => {
        // console.log("hello")
        setShowInfoDrawer(true);
        setTimeout(()=>{
          setShowInfoDrawer(false)
        },4000);
    };
    const openWarningDrawer = () => {
        // console.log("hello")
        setShowWarningDrawer(true);
         setTimeout(()=>{
          setShowWarningDrawer(false)
        },4000);
    };
  return (
    <div className=' screen red-bg'>
      <Helmet>
          <meta charSet="utf-8" />
          <title>Toast</title>
      </Helmet>
      <h1 className="component-name">Toast</h1>
    
      <div className='display-wrapper'>
            <div className='display_grid_drawer'>
            <Button 
                label="Launch Success toast"
                onClick={openSuccessDrawer}
                roundedType="extralarge"
                backgroundColor='green'
                variant='filled'
                size="large"
                disabled={false}
            />
            <Button 
                label="Launch Error toast"
                type='secondary'
                variant='filled'
                onClick={openErrorDrawer}
                roundedType="extralarge"
                size="large"
                disabled={false}
            />
            <Button 
                label="Launch Info toast"
                type='dark'
                variant='filled'
                onClick={openInfoDrawer}
                roundedType="extralarge"
                size="large"
                disabled={false}
            />
            <Button 
                label="Launch Warning toast"
                onClick={openWarningDrawer}
                backgroundColor="orange"
                variant='filled'
                roundedType="large"
                size="large"
                disabled={false}
            />


        </div>
      </div>
     

      <div className='props-sec'>
        <h3 className='props-header'>Props</h3>
        <PropsTable props={props} />
      </div>

      <Toast
        position='bottom-left'
        variant='error'
        message="something happened!!!"
        isOpen={showerrorDrawer}
        autoClose={true}
        
      />
      <Toast
        position='bottom-right'
        variant='info'
        message="this is info"
        isOpen={showinfoDrawer}
        autoClose={false}
      />
      <Toast
        position='top-right'
        variant='success'
        message="register is successful"
        isOpen={showsuccessDrawer}
        autoClose={true}
      />
      <Toast
        position='top-left'
        variant='warning'
        message="this is harm you!!"
        isOpen={showwarningDrawer}
        autoClose={false}
      />
      
    </div>
  );
}


const props = [
  {
    name: "autoClose",
    required: 'true',
    description: "true if you want to close toast automatically",
    possible_values: "boolean"
  },
  {
    name: "position",
    required: 'true',
    description: "where do you want to place your toast",
    possible_values: " 'top-right' 'top-left' 'bottom-right' 'bottom-left' "
  },
  {
    name: "variant",
    required: 'true',
    description: "choose the type of toast",
    possible_values: " 'success' 'warning' 'info' 'error' "
  },
  {
    name: "message",
    required: 'true',
    description: "message to be displayed in the toast",
    possible_values: "string"
  },
  {
    name: "isOpen",
    required: 'true',
    description: "parameter controlling the visibility if toast",
    possible_values: "boolean"
  },
]
export default ComponentScreen(ToastScreen);

